import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MbscSelect, MbscSelectOptions } from '@mobiscroll/angular';
import { MbscSelectOnFilterEvent } from '@mobiscroll/angular/dist/js/core/components/select/select';
import { NgbModal, NgbNav, NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { DirtyTrackingService } from 'src/app/core/dirty-tracking/dirty-tracking.service';
import { ListFilter } from 'src/app/core/list-filter.model';
import { PDxListItem, PDxLists } from 'src/app/core/PDxListItem.model';
import { PDxUserPermission } from 'src/app/core/PDxUserPermission.enum';
import { ajaxCall, DataTablesResponse } from 'src/app/core/services/ajax-call.service';
import { CloneService } from 'src/app/core/services/clone.service';
import { ConfirmService } from 'src/app/core/services/confirm.service';
import { RouterExtService } from 'src/app/core/services/router-ext.service';
import { UserPropertiesComponent } from 'src/app/core/user-properties/user-properties.component';
import { VERelationshipInformation } from 'src/app/vendors/models/ve-relationship-information.model';
import { VERelationshipSummary } from 'src/app/vendors/models/ve-relationship-summary.model';
import { EntityMoveComponent } from '../entity-move/entity-move.component';
import { LocationPropertiesComponent } from '../location-properties/location-properties.component';
import { EntityApprovalInformation } from '../models/entity-approval-information.model';
import { EntityFeatureInformation } from '../models/entity-feature-information.model';
import { EntityHeaderInformation } from '../models/entity-header-information.model';
import { EntityUserSummary } from '../models/entity-user-summary.model';
import { LocationSummary } from '../models/location-summary.model';
import { ViewEntityAssignmentComponent } from '../view-entity-assignment/view-entity-assignment.component';

@Component({
  selector: 'app-entity-mgmt',
  templateUrl: './entity-mgmt.component.html',
  styles: [
  ]
})
export class EntityMgmtComponent implements OnInit {

  entity: EntityHeaderInformation;
  nav: NgbNav;
  activeTab: string;

  constructor(private route: ActivatedRoute,
    private router: Router,
    private dirtyService: DirtyTrackingService,
    private location: Location,
    private confirmService: ConfirmService,
    private ajax: ajaxCall,
    private routerExtService: RouterExtService,
    private modalService: NgbModal,
    private confirm: ConfirmService,
    private cloneService: CloneService,
    private notifier: NotifierService) {
    this.userPermissionFilters.splice(0, 0, { value: null, text: 'Any' });
  }

  ngOnInit(): void {
    this.route.params.subscribe(routeParams => {
      this.loadHeader(routeParams.entityId);
      this.loadVendors(routeParams.entityId);
      this.loadApprovals(routeParams.entityId);
      this.loadFeatures(routeParams.entityId);
      this.activeTab = (routeParams.tab) || 'profile';
      this.resetFilters(routeParams.entityId);
      this.resetLocationFilters(routeParams.entityId);
    });
  }

  close(): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.routerExtService.closeOverlay();
  }

  loadHeader(entityId: string): void {
    this.entity = null;
    this.ajax.MakeCall<EntityHeaderInformation>('/Entity/Header', { entityId: entityId }).then((data) => {
      this.entity = data;
    }, () => { });
  }

  viewInTree(idx: number): void {
    var entities = this.entity.hierarchy.map((x) => x.value);
    entities.push(this.entity.entityId);
    entities.splice(idx + 1);
    entities.splice(0, 0, '/manage/entities');
    this.router.navigate(entities);
  }

  manageEntity(entityId: string): void {
    this.router.navigate(['/manage/entity-mgmt', entityId, this.activeTab]);
  }

  saveAccountCallback = (): void => {
    this.loadHeader(this.entity.entityId);
  }

  cancelAccountCallback = (): void => {
    // do nothing
  }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    if (!this.dirtyService.isClean()) {
      changeEvent.preventDefault();
    } else {
      var pathArray = ['/manage/entity-mgmt', this.entity.entityId, changeEvent.nextId];
      var url = this.router.createUrlTree(pathArray).toString();
      this.location.go(url);
    }
  }

  launchEntity(): void {
    this.confirmService.confirm('Launch Entity', 'Are you sure you want to launch this entity?', 'Launch Entity').then(() => {
      this.ajax.MakeCall<boolean>('/Entity/Launch', { entityId: this.entity.entityId }).then((data) => {
        this.entity.isLaunched = data;
      }, () => { });
    }, () => { });
  }

  move(): void {
    const modal = this.modalService.open(EntityMoveComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.entity = this.entity;
    modal.result.then(() => {
      this.loadHeader(this.entity.entityId);
    }, () => { });
  }

  vendorSearch: string = null;
  filteredVendors: VERelationshipSummary[] = [];
  vendors: VERelationshipSummary[] = [];
  editVendor: VERelationshipInformation = null;
  vendorDropDownIsOpen: boolean;

  masterFileOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
  };

  loadVendors(entityId: string): void {
    this.ajax.MakeCall<VERelationshipSummary[]>('/Vendor/Entity', { entityId: entityId }).then((data) => {
      this.vendors = data;
      this.approvalVendors = data.map((x) => { return { value: x.vendorId, text: x.vendorName } });
      this.filterVendors();
      this.addVendor(entityId);
    }, () => { });
  }

  filterVendors(): void {
    this.filteredVendors = this.vendors.filter(v => (!this.vendorSearch) || (v.vendorName.toLowerCase().indexOf(this.vendorSearch.toLowerCase()) >= 0));
  }

  addVendor(entityId: string): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.editVendor = new VERelationshipInformation();
    this.editVendor.entityId = entityId;
    this.editVendor.addAssignment = true;
    this.submitAttempt = false;
    if (this.relationshipForm) {
      this.relationshipForm.form.markAsPristine();
    }
  }

  viewVendor(vendorId: string, entityId: string): void {
    if (!this.dirtyService.isClean()) {
      return;
    }
    this.ajax.MakeCall<VERelationshipInformation>('/Vendor/Relationship', { vendorId: vendorId, entityId: entityId }).then((data) => {
      this.editVendor = data;
      this.submitAttempt = false;
      this.relationshipForm.form.markAsPristine();
    }, () => { });
  }

  filterCount: number = 0;
  allVendors: PDxListItem<string>[] = [];
  @ViewChild(NgForm) relationshipForm: NgForm;
  submitAttempt: boolean = false;
  vendorOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      var fCt = ++this.filterCount;
      this.allVendors = [];
      if (ev.filterText) {
        this.ajax.MakeCall<PDxListItem<string>[]>('/Vendor/DropDownList', { query: ev.filterText }, false).then((data) => {
          if (fCt == this.filterCount) {
            this.allVendors = data;
            this.validateCurrentVendor()
          }
        }, () => { });
      } else {
        this.validateCurrentVendor()
      }
      return false;
    },
    onChange: (ev: any) => {
      this.vendorDropDownIsOpen = false;
      setTimeout(() => {
        this.ajax.MakeCall<VERelationshipInformation>('/Vendor/Relationship', { vendorId: this.editVendor.vendorId, entityId: this.entity.entityId }).then((data) => {
          this.editVendor = data;
          this.editVendor.entityId = this.entity.entityId;
        }, () => { });
      }, 200);
    }
  };

  validateCurrentVendor(): void {
    if (this.editVendor.vendorId) {
      if (this.allVendors.filter((x) => x.value == this.editVendor.vendorId).length == 0) {
        this.editVendor.vendorId = null;
      }
    }
  }

  saveVendor(): void {
    this.submitAttempt = true;
    if (this.relationshipForm.invalid) {
      return;
    }

    this.ajax.MakeCall<string>('/Vendor/SaveRelationship', this.editVendor).then((aId) => {
      this.relationshipForm.form.markAsPristine();
      this.loadVendors(this.editVendor.entityId);
    }, () => { });
  }

  removeAssignment(): void {
    this.confirmService.delete('Remove Assignment', 'Are you sure that you want to remove this vendor?', 'Remove').then(() => {
      this.ajax.MakeCall('/Vendor/RemoveEntity', { vendorId: this.editVendor.vendorId, entityId: this.entity.entityId }).then(() => {
        this.relationshipForm.form.markAsPristine();
        this.loadVendors(this.editVendor.entityId);
      }, () => { });
    }, () => { });
  }

  // users
  filter: EntityUserListFilter;
  showList: boolean;
  results: DataTablesResponse<EntityUserSummary>;
  @ViewChild('exportUsersForm') exportUsersForm: ElementRef;

  assignmentStatusFilters: PDxListItem<boolean>[] = [
    { value: null, text: 'Here or Inherited' },
    { value: true, text: 'Here' },
    { value: false, text: 'Inherited' },
  ];
  userPermissionFilters: PDxListItem<PDxUserPermission>[] = PDxLists.PDxUserPermissions();
  statusFilters: PDxListItem<boolean>[] = [
    { value: null, text: 'Any' },
    { value: true, text: 'Active' },
    { value: false, text: 'Deactivated' }
  ];
  listingStatusFilters: PDxListItem<boolean>[] = [
    { value: null, text: 'Any' },
    { value: true, text: 'Whitelist' },
    { value: false, text: 'Blacklist' },
  ];

  selectStatusFilter(f: PDxListItem<boolean>): void {
    this.filter.userStatus = f;
    this.hideTheList();
  }
  selectUserPermissionFilter(f: PDxListItem<PDxUserPermission>): void {
    this.filter.userPermission = f;
    this.hideTheList();
  }
  selectAssignmentStatusFilter(f: PDxListItem<boolean>): void {
    this.filter.assignmentStatus = f;
    this.hideTheList();
  }
  selectListingStatusFilter(f: PDxListItem<boolean>): void {
    this.filter.listingStatus = f;
    this.hideTheList();
  }

  resetFilters(entityId: string): void {
    this.filter = new EntityUserListFilter(10, 'Name', 'asc');
    this.filter.entityId = entityId;
    this.filter.userStatus = this.statusFilters.filter(x => x.value === true)[0];
    this.filter.userPermission = this.userPermissionFilters[0];
    this.filter.assignmentStatus = this.assignmentStatusFilters[0];
    this.filter.listingStatus = this.listingStatusFilters[0];
    this.hideTheList();
  }

  showTheList(): void {
    if (!this.showList) {
      this.loadList(true);
    }
  }

  hideTheList(): void {
    this.showList = false;
  }

  loadList = (reset: boolean = false) => {
    if (reset) {
      this.filter.page = 1;
    }
    this.ajax.MakeCall<DataTablesResponse<EntityUserSummary>>('/Entity/FullUserList', this.filter).then(results => {
      this.results = results;
      this.showList = true;
    }, () => { console.log('error'); });
  }

  inputFieldChange(ev: KeyboardEvent): void {
    if (ev.key == 'Enter') {
      this.showTheList();
    }
  }

  blacklistEntity(userId: string): void {
    this.confirm.confirm('Blacklist Entity?', 'Are you sure that you want to remove all permissions from this entity and all of its children?').then(() => {
      this.ajax.MakeCall('/User/Blacklist', { userId: userId, entityId: this.entity.entityId }).then(() => {
        this.loadList();
      }, () => { });
    }, () => { });
  }

  resetPermissions(userId: string): void {
    this.confirm.confirm('Reset Entity to Inherit?', 'Are you sure that you want to reset this user\'s access to this entity and all of its children based on its parent?').then(() => {
      this.ajax.MakeCall('/User/ResetPermissions', { userId: userId, entityId: this.entity.entityId }).then(() => {
        this.loadList();
      }, () => { });
    }, () => { });
  }

  viewUser(userId: string): void {
    const modal = this.modalService.open(UserPropertiesComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.userId = userId;
    modal.result.then(() => { this.loadList(); }, () => { });
  }

  viewAssignment(userId: string): void {
    const modal = this.modalService.open(ViewEntityAssignmentComponent, { size: 'lg', beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.entityId = this.entity.entityId;
    modal.componentInstance.hierarchy = this.entity.hierarchy;
    modal.componentInstance.userId = userId;
    modal.result.then(() => { this.loadList(); }, () => { });
  }

  impersonateUser(userId: string): void {
    this.ajax.MakeCall<boolean>('/User/Impersonate', { userId: userId }).then(() => {
      window.location.href = window.location.origin + '/customer';
    }, () => { });
  }

  sendPasswordReset(userId: string): void {
    this.confirm.confirm('Send Password Reset', 'Are you sure you want to send this user an email?').then(() => {
      this.ajax.MakeCall<boolean>('/User/ResetEmail', { userId: userId }).then(() => {
        this.notifier.notify('info', 'This user has been sent a Password Reset email');
      }, () => { });
    }, () => { });
  }

  exportUsers(): void {
    this.exportUsersForm.nativeElement.submit();
  }

  // features
  featureInfo: EntityFeatureInformation;
  activeFeatureInfo: EntityFeatureInformation = new EntityFeatureInformation();
  filterLocations: LocationListFilter;
  resultLocations: DataTablesResponse<LocationSummary>;
  submitFeatureAttempt: false;
  @ViewChild('featureForm') featureForm: NgForm;
  loadFeatures(entityId: string): void {
    this.featureInfo = null;
    this.ajax.MakeCall<EntityFeatureInformation>('/Entity/Features', { entityId: entityId }).then((data) => {
      this.featureInfo = data;
      this.activeFeatureInfo = this.cloneService.deepClone(data);
      this.submitApprovalAttempt = false;
      if (this.featureForm) {
        this.featureForm.form.markAsPristine();
      }
    }, () => { });
  }

  saveFeatures(): void {
    this.submitApprovalAttempt = true;
    if (this.featureForm.invalid) {
      return;
    }
    this.ajax.MakeCall('/Entity/SaveFeatures', this.featureInfo).then((data) => {
      this.activeFeatureInfo = this.cloneService.deepClone(this.featureInfo);
      this.featureForm.form.markAsPristine();
      this.submitFeatureAttempt = false;
    }, () => { });
  }

  toggleAllowShopping(): void {
    if (!this.featureInfo.allowShopping) {
      this.featureInfo.allowInventory = false;
    }
  }

  // locations
  loadLocationList = (reset: boolean = false) => {
    if (reset) {
      this.filterLocations.page = 1;
    }
    this.ajax.MakeCall<DataTablesResponse<LocationSummary>>('/Entity/FullLocationList', this.filterLocations).then(data => {
      this.resultLocations = data;
    }, () => { console.log('error'); });
  }

  resetLocationFilters(entityId: string): void {
    this.filterLocations = new LocationListFilter(10, 'Name', 'asc');
    this.filterLocations.entityId = entityId;
    this.loadLocationList(true);
  }

  viewLocation(l: LocationSummary): void {
    const modal = this.modalService.open(LocationPropertiesComponent, { beforeDismiss: () => { return this.dirtyService.isClean(); } });
    modal.componentInstance.location = this.cloneService.deepClone(l) || { entityId: this.entity.entityId };
    modal.result.then(() => {
      this.loadLocationList();
    }, () => { });
  }

  deleteLocation(l: LocationSummary): void {
    this.confirm.delete('Remove Storage Location', 'Are you sure you want to remove this storage location?', 'Remove').then(() => {
      this.ajax.MakeCall<boolean>('/Entity/RemoveLocation', { locationId: l.locationId }).then(() => {
        this.loadLocationList();
      }, () => { });
    }, () => { });

  }

  // po approvals
  approvalInfo: EntityApprovalInformation;
  submitApprovalAttempt: boolean = false;
  @ViewChild('approvalForm') approvalForm: NgForm;
  approvalVendors: PDxListItem<string>[] = [];
  approvalVendorOptions: MbscSelectOptions = {
    filter: true,
    touchUi: false,
    theme: 'ios',
    themeVariant: 'light',
    selectMultiple: true,
    onFilter: (ev: MbscSelectOnFilterEvent) => {
      return true;
    },
    onChange: (ev: any) => {

    }
  };

  loadApprovals(entityId: string): void {
    this.approvalInfo = null;
    this.ajax.MakeCall<EntityApprovalInformation>('/Entity/Approvals', { entityId: entityId }).then((data) => {
      this.submitApprovalAttempt = false;
      this.approvalInfo = data;
      if (this.approvalForm) {
        this.approvalForm.form.markAsPristine();
      }
    }, () => { });
  }

  toggleApproval(b: boolean): void {
    this.approvalInfo.isRequired = b;
    this.approvalForm.form.markAsDirty();
  }

  togglePassToChildren(b: boolean): void {
    this.approvalInfo.passToChildren = b;
    this.approvalForm.form.markAsDirty();
  }

  saveApprovals(): void {
    this.submitApprovalAttempt = true;
    if (this.approvalForm.invalid) {
      return;
    }
    if (this.approvalInfo.levels.filter((ai) => { return ai.requireApproval && !ai.approvalAll && !ai.approveDollarAmount && !ai.approveNonFormulary && !ai.approveVendors }).length > 0) {
      return;
    }
    this.ajax.MakeCall<boolean>('/Entity/SaveApprovals', this.approvalInfo).then(() => {
      this.notifier.notify('info', 'This information has been saved.');
      this.submitApprovalAttempt = false;
      this.approvalForm.form.markAsPristine();
    }, () => { });
  }

  editApprovalsHere(): void {
    this.approvalInfo.inherited = false;
    this.approvalForm.form.markAsDirty();
  }

  blacklistApprovals(): void {
    this.confirm.confirm('Blacklist Approvals', 'Are you sure you want to turn off approvals for this entity?').then(() => {
      this.ajax.MakeCall<boolean>('/Entity/SaveApprovals', { entityId: this.approvalInfo.entityId, isRequired: false }).then(() => {
        this.notifier.notify('info', 'This information has been saved.');
        this.loadApprovals(this.approvalInfo.entityId);
      }, () => { });
    }, () => { });
  }

  resetApprovals(): void {
    this.confirm.confirm('Reset Approvals', 'Are you sure you want to reset approvals to inherit for this entity?').then(() => {
      this.ajax.MakeCall<boolean>('/Entity/ResetApprovals', { entityId: this.approvalInfo.entityId }).then(() => {
        this.notifier.notify('info', 'This information has been saved.');
        this.loadApprovals(this.approvalInfo.entityId);
      }, () => { });
    }, () => { });

  }
}

class EntityUserListFilter extends ListFilter {
  entityId: string;
  nameFilter: string;
  userStatus: PDxListItem<boolean>;
  userPermission: PDxListItem<PDxUserPermission>;
  assignmentStatus: PDxListItem<boolean>;
  listingStatus: PDxListItem<boolean>;
}

class LocationListFilter extends ListFilter {
  entityId: string;

}